import { Component } from '@angular/core';
import { OgService } from '@app/core/services/og.service';
import { SeoService } from '@app/core/services/seo.service';
import { LanguageConfigService } from '../language-config.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-deals',
    templateUrl: './deals.component.html',
    styleUrls: ['./deals.component.scss']
})
export class DealsComponent {
    public viewDeals: boolean = true;

    public constructor(
        private seoService: SeoService,
        private ogService: OgService,
        public languageConfigService: LanguageConfigService,
        public activatedRoute: ActivatedRoute
    ) {
        this.languageConfigService
            .setActivatedRoute(this.activatedRoute)
            .updateLanguageFromUrl('deals')
            .subscribe(() => {
                this.seoService.addTitle('Ofertas');
                this.seoService.addCanonical('wiki/deals');
                this.ogService.addOpenGraphMetadata({ url: 'wiki/deals' });
                this.seoService.addMetaName('keywords', 'ofertas, saldo, beneficios, oportunidades, descuento, dinero');
                this.seoService.addMetaName('description', '¿Te gustaría obtener beneficios operando en Saldo? Te presentamos "Ofertas".');
            });
    }
}
